import { findElementAll, selectedElementAll, useElements } from "../utils/element-handlers.utils";

function hasHiddenContent(
  element: HTMLElement
): boolean {
  const { offsetHeight, scrollHeight } = element;
  return scrollHeight > offsetHeight;
}

function expandFeatureContent(
  featureElement: HTMLElement,
  showOnExpandElements: HTMLElement[]
): void {
  featureElement.classList.add('nobu-feature-expanded');
  useElements(showOnExpandElements, {
    style: 'display: block;',
  });
}

function collapseFeatureContent(
  featureElement: HTMLElement,
  showOnExpandElements: HTMLElement[]
): void {
  featureElement.classList.remove('nobu-feature-expanded');
  useElements(showOnExpandElements, {
    style: 'display: none;',
  });
}

export default function initFeatureComponents() {
  selectedElementAll('article.nobu-feature', featureElement => {
    const infoInnerElement = featureElement.querySelector<HTMLElement>('.nobu-feature-info-inner');
    const buttonPadElement = featureElement.querySelector<HTMLElement>('.nobu-feature-info-bottom');
    const expandButtonElement = featureElement.querySelector<HTMLElement>('.nobu-feature-expand-btn');
    const collapseButtonElement = featureElement.querySelector<HTMLElement>('.nobu-feature-collapse-btn');
    const showOnExpandElements = findElementAll('.nobu-feature-show-on-expand', featureElement);

    if (
      !infoInnerElement
      || !(buttonPadElement && expandButtonElement && collapseButtonElement)
    ) return;

    const checkForHiddenContent = () => {
      buttonPadElement.style.display = 'none';

      if (showOnExpandElements.length > 0 || hasHiddenContent(infoInnerElement)) {
        featureElement.classList.add('nobu-feature-hidden-content');
        buttonPadElement.style.display = 'block';
      }
    }

    expandButtonElement.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      expandFeatureContent(featureElement, showOnExpandElements);
    });

    collapseButtonElement.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      collapseFeatureContent(featureElement, showOnExpandElements);
    });

    checkForHiddenContent();

    window.addEventListener('resize', checkForHiddenContent);
    // featureElement.addEventListener('transitionend', checkForHiddenContent);

    // for the slider: check the function "initNobuFeature" in nobu.main.js file
  });
}
